import React from 'react'
import { Card, CardBody, CardHeader, Col } from 'reactstrap'
import { Badges, H3, H5, P } from '../../../../AbstractElements'
import SvgIcon from '../../../../Utils/CommonComponents/CommonIcons/CommonSvgIcons'
import { progressItemData } from '../../../../Data/DashboardsData/DefaultData'
import ReactApexChart from 'react-apexcharts'

export default function ProgressItemCards() {
    return (
        <>
            {progressItemData.map((item) => (
                <Col xl={3} sm={6} key={item.id}>
                    <Card className="progress-items">
                        <CardHeader className="pb-0">
                            <div className="d-flex justify-content-between">
                                <div>
                                    <div className="d-flex gap-2">
                                        <H5>{item.title}</H5>
                                        <Badges color="" className={`align-items-center d-flex badge-light-${item.arrowColor}`}>
                                            <SvgIcon className='feather me-1 pt-0' iconId={item.arrowIcon} />
                                            <span>{item.percent}%</span>
                                        </Badges>
                                    </div>
                                    <H3 className="mt-3">{item.rate}</H3>
                                </div>
                                <div className={`flex-shrink-0 bg-light-${item.color}`}>
                                    <SvgIcon className={`svg-w-23 fill-${item.color}`} iconId={item.icon} />
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody className="progress-card pt-0">
                            <div>
                                <P>{item.value}% since Last Month</P>
                            </div>
                            <div className="order-chart">
                                <div className="chart" id="sale-chart">
                                    <ReactApexChart options={item.chart} series={item.chart.series} height={item.chart.height} type={item.chart.type} />
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            ))}
        </>
    )
}